import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class CompanyBalances extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/company-balances'
    }
}

export default new CompanyBalances()
